import React,{useEffect} from 'react';
import Header from '../../components/Header';
import SignUpMain from './SignInMain';
import Footer from '../../components/Footer';


const SignIn = () => {
      useEffect(() => {
      document.title = "Membership Login | Society of Aquaculture Professionals";
    }, []);
  return (
    <>
      <Header/>

      <SignUpMain />

      <Footer/>
    </>
  );
};

export default SignIn;
